import { Component, inject, Input } from '@angular/core';
import { ModalService } from '../../../../../services/modal.service';
import { ApplicationStateService } from '../../../../../services/application-state.service';
import { AssetService } from '../../../../../services/asset.service';
import { ModalableAccessCode } from '../../../../../models/modalable-access-code';
import { AccessCode } from '../../../../../models/user-data';
import { UserDataService } from '../../../../../services/user-data.service';
import { ModalComponent } from '../../../../../models/modal-component';
import { NgClass } from '@angular/common';
import { AccessService } from '../../../../../services/access.service';

@Component({
    selector: 'app-access-code-modal',
    templateUrl: './access-code-modal.component.html',
    styleUrls: ['./access-code-modal.component.scss'],
    standalone: true,
    imports: [
        NgClass
    ]
})
export class AccessCodeModalComponent extends ModalComponent {

    @Input() declare modalable: ModalableAccessCode;
    accessService = inject(AccessService);
    applicationStateService = inject(ApplicationStateService);
    private modalService = inject(ModalService);
    private userDataService = inject(UserDataService);
    assetService = inject(AssetService);

    selectCode(code: AccessCode): void {
        this.userDataService.useAccessCode(code).then(() => {
            location.reload();
        });
        this.modalService.closeModal(this.getId());
    }

    getId(): string {
        return ModalableAccessCode.MODAL_ID;
    }

    close(): void {
        $('html')
            .css('cursor', 'initial');
    }
}
